export const PENDING_APPROVAL_DISABLE_REASON = 'PendingApproval'

// Same rule the backend uses to reject enable/disable with 409: a reason the company cannot manage
export const hasSystemDisableReason = (user) => {
  return !!user && !user.active && user.disabled_reason?.manually_assignable === false
}

export const isPendingApproval = (user) => {
  return hasSystemDisableReason(user) && user.disabled_reason.name === PENDING_APPROVAL_DISABLE_REASON
}
